import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './styles.css';
import NHFetch from '../../utils/NHFetch.js';

const yxxtBasicUrl = 'api/zhxg-yxxt'; //迎新管理服务后台接口基础路径
const errMaxCount = 3; // 请求异常最大次数
const speed = 60 * 1000; //轮询时间间隔
const pageSize = 10; //分页显示每页数据数量
/**
 * * 少数民族报到率
 * Author: zengxiangkai@ly-sky.com
 * Created on: 2018-07-04
 * Version: 1.0
 * Modify log:
 */
class IndexComponent extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            errCount: 0, //连续请求错误次数
            barData: [], //各学院报到统计数据
            page: 0, //当前显示的页数
            activeBarData: [] //当前显示的数据
        }

        this.polling; //轮询定时器
        this.activePolling;
    }

    componentDidMount() {
        this.getData();
    }

    componentWillUnmount() {
        if (this.polling) {
            clearTimeout(this.polling);
        }
        if (this.activePolling) {
            clearInterval(this.activePolling);
        }
    }

    /**
     * * 获取少数民族报到率
     * @memberof IndexComponent
     */
    getData = () => {
        NHFetch(yxxtBasicUrl + '/sstj/getRateOfNationalitiesReported', 'GET')
            .then(res => {
                if (res && res.data) {
                    this.polling = setTimeout(() => {
                        this.getData();
                    }, speed);
                    let data = res.data;
                    // let data = [
                    //     {pm: 1, bdl: 0.3654, mzmc: '汉族'},
                    //     {pm: 1, bdl: 0.3655, mzmc: '回族'},
                    //     {pm: 1, bdl: 0.3650, mzmc: '维吾尔族'},
                    //     {pm: 1, bdl: 0.12345, mzmc: '蒙古族'},
                    //     {pm: 1, bdl: 0.9655, mzmc: '朝鲜族'},
                    //     {pm: 1, bdl: 0.9654, mzmc: '汉族'},
                    // ]
                    // 对数据进行排序
                    data.sort(function (a, b) {
                        return b.bdl - a.bdl;
                    });

                    let barData = [];
                    let pageItems = [];

                    //如果数据量超过每页最大显示数量，则做分页显示处理
                    data.map((item, index) => {

                        pageItems.push(item);

                        if ((index + 1) % pageSize == 0 || index == data.length - 1) {
                            barData.push(pageItems);
                            pageItems = [];
                        }
                    });

                    this.setState({errCount: 0, barData: barData, activeBarData: barData[0]}, () => {

                        if (this.activePolling) {
                            clearInterval(this.activePolling);
                        }

                        //隔5秒换页
                        this.activePolling = setInterval(() => {
                            let {page, barData} = this.state;
                            const length = barData.length;

                            if (page + 1 >= length) {
                                page = 0;
                            } else {
                                page += 1;
                            }
                            let activeBarData = barData[page];

                            this.setState({page, activeBarData});
                        }, 5000);
                    });

                }
            }).catch(err => {
            let errCount = this.state.errCount;
            //如果请求异常次数未超过最大次数限制，则继续尝试
            if (errCount < errMaxCount) {
                this.polling = setTimeout(() => {
                    this.getData();
                }, speed);
                this.setState({errCount: errCount + 1});
            } else {
                //异常超过3次后终止轮询
                if (this.polling) {
                    clearTimeout(this.polling);
                }
                if (this.activePolling) {
                    clearInterval(this.activePolling);
                }

            }
        });
    };

    /**
     * *
     * @memberof IndexComponent
     */
    getRateOfCollegeGirlsOption = () => {
        const {activeBarData = []} = this.state;

        return activeBarData.map((item, index) => {
            return (
                <div
                    className={styles.bottom_item}
                    key={item.pm}
                >
                    <div className={styles.zy}>
                        {item.mzmc}
                    </div>
                    <div className={classNames(styles.num)}>
                        {
                            (item.bdl === 0 || item.bdl === 1) ? `${item.bdl * 100}%` : `${(item.bdl * 100).toFixed(1)}%`
                        }
                    </div>
                </div>
            );
        });
    }

    render() {
        return (
            <div className={styles.bottom_list}>
                {this.getRateOfCollegeGirlsOption()}
            </div>
        )
    }

}

IndexComponent.defaultProps = {}

IndexComponent.propTypes = {
    rem: PropTypes.number,
}

export default IndexComponent;


// WEBPACK FOOTER //
// ./containers/Show-gdnh/_CardBox5.js